import React, { useState, useMemo } from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import "jspdf/dist/polyfills.es.js";
import EditableField from "./EditableField";
import { skills } from "./DataForScience";
import DataScienceSkillsCircleLoop from "./DataScienceSkillsCircleLoop";

const useHover = () => {
  const [hovered, setHovered] = useState();

  const eventHandlers = useMemo(
    () => ({
      onMouseOver() {
        setHovered(true);
      },
      onMouseOut() {
        setHovered(false);
      },
    }),
    []
  );
  return [hovered, eventHandlers];
};

const DataScienceCv = (props) => {
  const [cv, setCV] = useState({
    avatar: {
      default:
        "https://www.sibberhuuske.nl/wp-content/uploads/2016/10/default-avatar.png?fbclid=IwAR3ohCaqwU-59D8GDRjff4TttyYumvDz4PXEL4HflKLYcq5Rh7Zd4xpgB-U",
      value:
        "https://scontent-ams4-1.xx.fbcdn.net/v/t1.0-9/48387141_1518412288303383_4112549134311882752_o.jpg?_nc_cat=103&ccb=2&_nc_sid=cdbe9c&_nc_ohc=YhoBhUqvTJMAX_GUkPW&_nc_ht=scontent-ams4-1.xx&oh=f3f5c1fa58202e10781386c526fb6611&oe=6022DAE3",
    },
    name: {
      default: "Full Name",
      value: "Aleksandra Janakievska",
    },
    title: {
      default: "Proffesional Title",
      value: "Data Scientist",
    },
    about: {
      default: "About Me",
      value:
        "HigMy acouarate and experiended Data Scientist adept at colecting,analyzing,and interpreting large datasets,developing new forecasting models,and performing data management tasks.",
    },
    inputMail: {
      default: "Email",
      value: "aleksandraxx@wearelaika.com",
    },
    inputPhone: {
      default: "Phone number",
      value: "xxxxxx",
    },
    workBio: {
      default: "Work Experience",
      value: "Work Experience",
    },
    workPosition: {
      default: "Position/Title",
      value: "Data Scientist",
    },
    workPlace: {
      default: "Company",
      value: "Rocket Corp",
    },
    workHistory: {
      default: "Data xxx",
      value: "11/2019 - Present",
    },
    workTask: {
      default: "Place",
      value: "Skopje",
    },
    workTask1: {
      default: "Achievements/Task",
      value: "Achievements/Task",
    },
    workPara: {
      default: "Accomplishment 1",
      value:
        "- Collecting,analyzing, and interpreting raw data from various websites.",
    },
    workPara1: {
      default: "Task 1",
      value:
        "- Collaborating with the Operations and Technology Department on the development of new automated data management/analysis software which increases the overal productivity and cut unnecessary cost.",
    },
    workPara2: {
      default: "Task 2",
      value: "- Maintaining and managing company's MS SQL server",
    },
    secondTitle: {
      default: "Title",
      value: "SKILLS",
    },
    // languageSkill: {
    //   default: "language",
    //   value: "Python",
    // },
    // languageSkill1: {
    //   default: "language",
    //   value: "MySQL",
    // },
    // languageSkill2: {
    //   default: "language",
    //   value: "PHP",
    // },
    // languageSkill3: {
    //   default: "language",
    //   value: "R",
    // },
    // languageSkill4: {
    //   default: "language",
    //   value: "C",
    // },
    work: {
      default: "Work",
      value: "Data Science Intern",
    },
    workEducation: {
      default: "Work",
      value: "Random CO",
    },
    workHistory1: {
      default: "Data xxx",
      value: "07/2011 - 10/2019",
    },
    workTasks: {
      default: "Place",
      value: "Skopje",
    },
    workTasks1: {
      default: "Achievements/Task",
      value: "Achievements/Task",
    },
    workParagraph: {
      default: "Accomplishment 1",
      value:
        "- Reported actionable,statistical,and analytical insights to executives for effective strategic positioning in the market place.",
    },
    workParagraph1: {
      default: "Accomplishment 1",
      value:
        "- Shadowed data scientists and assist in developing algorithms for predictive modeling.",
    },
    workParagraph2: {
      default: "Accomplishment 1",
      value:
        "- Analyzed and processed sophisticated data sets using SAS,MySQL,and Excel.",
    },
    workParagraph3: {
      default: "Accomplishment 1",
      value: "- Wrote python scripts to automate everyday tasks.",
    },
    workEdu: {
      default: "Education",
      value: "Founder",
    },
    workEdu1: {
      default: "Education",
      value: "Founder",
    },
    workInfo: {
      default: "Study",
      value: "The Boring Company",
    },
    workInfo1: {
      default: "Thind Learned",
      value: "Raised $10m by selling 20.000 flamethrowers in 4 days.",
    },
    workInfo2: {
      default: "Thind Learned1",
      value: "Raised $10 by selling 50.000 baseball caps",
    },
    workInfo3: {
      default: "Thind Learned2",
      value:
        "Hyperloop -- an ultra high-speed underground public transporatiton sistem in which passengers are transported on autonomous electric pods traveling at 600+ miles per hour in a pressurized cabin.",
    },
    titleThird: {
      default: "CERTIFICATES",
      value: "CERTIFICATES",
    },
    paraData: {
      default: "Data",
      value: "Data Analysis",
    },
    paraData1: {
      default: "Data1",
      value: "Machine learning",
    },
    titleFourth: {
      default: "Languages",
      value: "LANGUAGES",
    },
    paraLanguage: {
      default: "Data",
      value: "English",
    },
    paraLanguage1: {
      default: "Data1",
      value: "Full Professional Profiency",
    },
    titleFifth: {
      default: "Languages",
      value: "INFORMAL EDUCATION",
    },
    paraLanguage3: {
      default: "button",
      value: "Artificial Intelegence Webinar",
    },
    paraLanguage4: {
      default: "button1",
      value: "Business Analytics Course",
    },
    lastTitle: {
      default: "Education",
      value: "EDUCATION",
    },
    academy: {
      default: "Education",
      value: "DATA SCIENCE ACADEMY",
    },
    company: {
      default: "Education",
      value: "Brainster",
    },
    lastTitle1: {
      default: "Education",
      value: "Financial Managment",
    },
    academy1: {
      default: "Education",
      value: "Faculty of Economy,University 'St. Cyril and Methodius' ",
    },
  });

  const downloadPDF = () => {
    const page = document.getElementById("doctopdf");
    page.style.marginTop = "-" + page.offsetHeight * 1.3 + "px";
    html2canvas(page).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(imgData, "JPEG", 0, 0);
      pdf.save("dataScience.pdf");
      props.handleShow(true);
    });
  };

  return (
    <div id="doctopdf" className="DataScienceCV ">
      <div className="row p-4 border-bottom border-sedondary">
        <div className="col-md-3">
          <EditableField
            cv={cv}
            setCV={setCV}
            field="avatar"
            type="file"
            editMode={props.editMode}
            handleHover={props.handleHover}
          />
        </div>
        <div className="col-md-9 innerInput">
          <div className="m-0 font-weight-bold CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="name"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="proffesion">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="title"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="aboutProff">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="about"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>
      </div>
      <div className="row py-2 border-bottom border-sedondary">
        <div className="col-md-12 ">
          <div className="d-flex justify-content-center">
            <div className="CVPARA m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="inputMail"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
            <span className="ml-2 mr-5">
              <i className="fas fa-envelope"></i>
            </span>

            <span className="mr-2">
              <i className="fas fa-phone"></i>
            </span>
            <div className="CVPARA m-0">
              <EditableField
                cv={cv}
                setCV={setCV}
                field="inputPhone"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row p-4">
        <div className="col-md-6">
          <div className="py-2 font-weight-bold ">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workBio"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="py-2 font-weight-bold">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPosition"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="py-2 font-weight-bold">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPlace"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="d-flex justify-content-between">
            <div className="CVPARA">
              <small>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="workHistory"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </small>
            </div>
            <div className="CVPARA">
              <small>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="workTask"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </small>
            </div>
          </div>
          <div className="CVPARA">
            <small>
              <EditableField
                cv={cv}
                setCV={setCV}
                field="workTask1"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </small>
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPara"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPara1"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workPara2"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="py-2 font-weight-bold CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="secondTitle"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>

          <div className="d-flex justify-content-between">
            <div className="pt-3">
              {skills.map((el, index) => {
                return (
                  <div key={index}>
                    <DataScienceSkillsCircleLoop
                      lang={el.programLanguage}
                      solid={el.solidCircle}
                      regular={el.regularCircle}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div className="row px-4">
        <div className="col-md-6">
          <div className="py-2 font-weight-bold">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="work"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="py-2 font-weight-bold">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workEducation"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="d-flex justify-content-between">
            <div className="CVPARA">
              <small>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="workHistory1"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </small>
            </div>
            <div className="CVPARA">
              <small>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="workTasks"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </small>
            </div>
          </div>
          <div className="CVPARA">
            <small>
              <EditableField
                cv={cv}
                setCV={setCV}
                field="workTasks1"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </small>
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workParagraph"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workParagraph1"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workParagraph2"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="workParagraph3"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>
        <div className="col-md-6  innerInput">
          <div className="py-2 font-weight-bold">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="titleThird"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="paraData"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="paraData1"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="py-2 font-weight-bold">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="titleFourth"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="paraLanguage"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <small>
              <EditableField
                cv={cv}
                setCV={setCV}
                field="paraLanguage1"
                editMode={props.editMode}
                handleHover={props.handleHover}
              />
            </small>
          </div>
          <div className="py-2 font-weight-bold">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="titleFifth"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <button className="btn btn-secondary cvBtn my-2 mr-2">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="paraLanguage3"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </button>
          <button className="btn btn-secondary cvBtn">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="paraLanguage4"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </button>
        </div>
      </div>
      <div className="row p-4 mb-5">
        <div className="col-md-6">
          <div className="py-2 font-weight-bold">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="lastTitle"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="py-2 font-weight-bold">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="academy"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            {" "}
            <EditableField
              cv={cv}
              setCV={setCV}
              field="company"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="d-flex justify-content-between">
            <div className="CVPARA">
              <small>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="workHistory1"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </small>
            </div>
            <div className="CVPARA">
              <small>
                <EditableField
                  cv={cv}
                  setCV={setCV}
                  field="workTasks"
                  editMode={props.editMode}
                  handleHover={props.handleHover}
                />
              </small>
            </div>
          </div>
          <div className="py-2 font-weight-bold">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="lastTitle1"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
          <div className="CVPARA">
            <EditableField
              cv={cv}
              setCV={setCV}
              field="academy1"
              editMode={props.editMode}
              handleHover={props.handleHover}
            />
          </div>
        </div>
        <div className="col-md-6  innerInput"></div>
      </div>
      <div className="row mb-5">
        <div className="col-md-12 text-right innerInput">
          <button
            className="btn buttonHome"
            data-html2canvas-ignore="true"
            onClick={downloadPDF}
          >
            DOWNLOAD
          </button>
        </div>
      </div>
    </div>
  );
};

export default DataScienceCv;
